import { render, staticRenderFns } from "./PriceLevelDashboard.vue?vue&type=template&id=87caf72a&scoped=true&"
import script from "./PriceLevelDashboard.vue?vue&type=script&lang=js&"
export * from "./PriceLevelDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PriceLevelDashboard.vue?vue&type=style&index=0&id=87caf72a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87caf72a",
  null
  
)

export default component.exports